<template>
  <div :class="{'inline': inline}">
    <slot v-if="until"></slot>
    <span v-if="!until" class="skeleton-text">
      skeltonskeletonskeletonskeleton
    </span>
  </div>
</template>
<script>
export default {
  props: {
    until: {},
    inline: {
      default: false
    },
  },
}
</script>
<style lang="scss">
.inline {
  display: inline-block;
}
.skeleton-text {
  background: #E6E6E6;
  border-radius: 4px;
  color: transparent;
  cursor: progress;
  background: linear-gradient(0.25turn, transparent, #fff, transparent),
  linear-gradient(#eee, #eee),
  radial-gradient(38px circle at 19px 19px, #eee 50%, transparent 51%),
  linear-gradient(#eee, #eee);
  background-repeat: no-repeat;
  background-size: 315px 250px, 315px 180px, 100px 100px, 225px 30px;
  background-position: -315px 0, 0 0, 0px 190px, 50px 195px;
  animation: loading 1.5s infinite;

  @keyframes loading {
    to {
      background-position: 315px 0, 0 0, 0 190px, 50px 195px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/skeleton/skeleton-text.vue